import "babel-polyfill";
import Vue from "vue";
import "@/register_global_dependencies";
import CatalogDetailAddCartArea from "@/components/CartPC/CatalogDetailAddCartArea/CatalogDetailAddCartArea.vue";

document.addEventListener("DOMContentLoaded", () => {
  const node = document.getElementById("cart2019-add-cart-area")!;
  const props = JSON.parse(node.getAttribute("data")!);
  new Vue({
    render: h => h(CatalogDetailAddCartArea, { props })
  }).$mount("#cart2019-add-cart-area");
});
